type AnyPointerEvent = MouseEvent | TouchEvent | PointerEvent;

export const getClientXYFromEvent = (
  ev: AnyPointerEvent,
): { x: number; y: number } | null => {
  // TouchEvent
  if (typeof TouchEvent !== 'undefined' && ev instanceof TouchEvent) {
    const t = ev.touches?.[0] ?? ev.changedTouches?.[0];
    if (!t) {
      return null;
    }
    return { x: t.clientX, y: t.clientY };
  }
  // PointerEvent
  if (typeof PointerEvent !== 'undefined' && ev instanceof PointerEvent) {
    return { x: ev.clientX, y: ev.clientY };
  }
  // MouseEvent (fallback)
  if (ev instanceof MouseEvent) {
    return { x: ev.clientX, y: ev.clientY };
  }
  return null;
};
